import * as React from 'react';
import { Box, Typography } from '@mui/material';

interface LabelProps {
  id?: string;
  label: string;
  styled: any;
  children: React.ReactNode;
}
export default function Label(props: LabelProps) {
  const { label, children, styled={}} = props;

  return (
    <Box display='flex' flexDirection='row' alignItems='center'>
      <Box>
        <Typography variant="subtitle1"
          sx={{
            p: .5,
            fontSize: '16px',
            color: 'grey',
            ...styled
          }}
        >
          {label}
        </Typography>
      </Box>
      {children}
    </Box>
  );
}